import {
    barkApi,
    _t,
    ModalManager,
    number_format,
    continueToBusinessAddress,
    initializeGooglePlacesAutoComplete,
    isUSTaxComplianceActive,
    isUSTaxCompliant,
    saveBusinessAddress,
    tracking,
    getLinkAttribution
} from '@bark/bark-core';
import {
	initCardModal,
	confirmSetupIntent,
	taxWord,
	clearModal,
	showCardModal as ccShowCardModal,
	showModalErrorText,
} from '../../../components/payments/credit-card';
import { getPrimaryPaymentMethod } from '../../../components/payments/payment-methods';
import {currency as currencyFormat, currency} from "@bark/bark-core/src/helpers/number-formatting";

export function EliteProNotSubscribed() {
	const modalManager = new ModalManager();

	/**
	 * Bark global
	 * @type {object}
	 */
	var Bark = (window.Bark = window.Bark || {});

	/**
	 * Bark.settings global
	 * @type {object}
	 */
	var settings = (Bark.settings = Bark.settings || {});

	/**
	 * Bark.settings.elite global
	 * @type {object}
	 */
	var elite = (settings.elitePro = settings.elitePro || {});

	/**
	 * Load queue
	 */
	var loadQueue;

	/**
	 * A coupon to discount the purchase, if available
	 */
	var freeTrialCoupon = null;

	/**
	 * @type {string|null} A coupon code as a result of a marketing campaign
	 */
	var marketingCoupon = null;

	/**
	 * The ID of a plan to purchase whilst in a purchase flow
	 */
	var planIdToPurchase;

	/**
	 * Handlebars template for the loading modal
	 * @type {HandlebarsTemplateDelegate<any>}
	 */
	var eliteWaitingModal = window.Handlebars.compile(
		document.getElementById('elite-pro-waiting-modal-template').innerHTML,
	);

	/**
	 * Handlebars template for the error modal
	 * @type {HandlebarsTemplateDelegate<any>}
	 */
	var eliteErrorModal = window.Handlebars.compile(
		document.getElementById('elite-pro-error-modal-template').innerHTML,
	);

	var couponSubscriptionRow;

	let standardCardModalFooterHtml;

	const handleCardModalSuccess = (token) => {
		elite.showLoading();

		confirmSetupIntent($creditModal.data('user-id'), token.id)
			.then(() => {
				purchaseElitePro(planIdToPurchase, marketingCoupon);
			})
			.catch(() => {
				Bark.hideLoading();
				showPurchaseError(_t('seller_settings_elite-pro:payment-authenticate-card-fail'));
			});
	};

	const handleCardModalCancel = () => {
		marketingCoupon = null;
		overridePaymentLabelling = null;
	};

	let $creditModal;

	let paymentMethod;

	let USTaxCompliantStatus;

	const LANDING_PAGE = 'landing-page';
	const DASHBOARD = 'benefits-dashboard';

	/**
	 * A list of the available subscriptions
	 * @type {Array}
	 */
	elite.availableSubscriptions = null;

	/**
	 * Description of the seller
	 */
	elite.seller = null;

	/**
	 * The primary category for this seller
	 */
	elite.primaryCategory = null;

	/**
	 * Get the subscriptions available to a seller
	 */
	elite.getSubscriptions = function () {
		if (elite.availableSubscriptions) {
			return elite.availableSubscriptions;
		}

		barkApi(
			'seller/available-subscriptions',
			{},
			function (e) {
				if (e.data.length) {
					elite.availableSubscriptions = e.data;
					loadQueue.subscriptions.resolve();
					return;
				}

				loadQueue.subscriptions.reject({});
			},
			function (error) {
				loadQueue.subscriptions.reject(error);
			},
		);
	};

	/**
	 * Get a description for the seller
	 */
	elite.getSelf = function () {
		barkApi(
			'seller/self',
			{},
			function (e) {
				elite.seller = e.data;
				loadQueue.sellerSelf.resolve();
			},
			function (error) {
				loadQueue.sellerSelf.reject(error);
			},
		);
	};

	/**
	 * Where eligible, get a unique coupon code for this seller
	 */
	elite.getDiscountCode = function () {
		barkApi(
			'seller/subscription-discount-code',
			{},
			function (e) {
				if (e.status) {
					freeTrialCoupon = e.code || null;
				}
				loadQueue.couponCode.resolve();
			},
			function (error) {
				loadQueue.couponCode.reject(error);
			},
		);
	};

	/**
	 * Get the primary category for this seller
	 */
	elite.getPrimaryCategory = function () {
		barkApi(
			'seller/primary-category',
			{},
			function (e) {
				if (e.status) {
					elite.primaryCategory = e.data;
				}
				loadQueue.primaryCategory.resolve();
			},
			function (error) {
				loadQueue.primaryCategory.reject(error);
			},
		);
	};

	let overridePaymentLabelling = null;

	/**
	 * Initialise the page
	 */
	async function initPage() {
		const eliteProPage = document.querySelector('#elite-pro-edge-page');
		if (eliteProPage) {
			initEdgeElitePro(eliteProPage.dataset.page);

			return;
		}

		var loadingThisTime = [];
		var x;

		if (loadQueue) {
			// Already loaded
			return;
		}

		loadQueue = {
			sellerSelf: $.Deferred(),
			subscriptions: $.Deferred(),
			couponCode: $.Deferred(),
			primaryCategory: $.Deferred(),
		};

		$creditModal = initCardModal(
			'.js-card-payment-modal',
			handleCardModalSuccess,
			handleCardModalCancel,
			handleCardModalCancel,
		);

		const params = new URLSearchParams(location.search);
		const allowRedirectTest = !params.has('nr');

		if (allowRedirectTest) {
			const paymentError = await Bark.api(
				`/user/${$creditModal.data('user-id')}/billing/payment-error/invoice/latest`,
			);

			if (paymentError?.data) {
				// The seller is in a broken Elite State
				document.location = '/settings/billing/saved_card/?fpt=ep';
				return;
			}
		}

		paymentMethod = await getPrimaryPaymentMethod(
			$('.js-card-payment-modal').data('seller-profile-id'),
		);

		elite.getSubscriptions();
		elite.getSelf();
		elite.getDiscountCode();
		elite.getPrimaryCategory();

		for (x in loadQueue) {
			loadingThisTime.push(loadQueue[x]);
		}

		$.when
			.apply($, loadingThisTime)
			.then(function () {
				fillPlaceholders();
				$('.waiting').removeClass('waiting');
			})
			.fail(function () {
				$('.waiting').removeClass('waiting');
				$('.inactive-subscription-container').addClass('d-none');
				$('.js-page-load-error').removeClass('d-none');
			});

		if (isUSTaxComplianceActive()) {
			USTaxCompliantStatus = await isUSTaxCompliant();
			if (!USTaxCompliantStatus) {
				initializeGooglePlacesAutoComplete();
			}
		}
	}

	function initEdgeElitePro(variant) {
		if (window.EliteProDashboard) {
			switch (variant) {
			case LANDING_PAGE:
				initEliteProLandingPage();
				break;
			case DASHBOARD:
				initEliteProDashboard(false);
				break;
			default:
				tracking(
					'Elite Pro Edge Page',
					'Elite Pro dashboard unknown page variant requested: ' + variant,
				);
				break;
			}
		} else {
			tracking(
				'Elite Pro Edge Page',
				'Elite Pro dashboard react app not loaded',
			);
		}
	}

	function initEliteProLandingPage() {
		window.EliteProDashboard.launchModule(
			LANDING_PAGE,
			'__rctEliteProLandingPage',
			{
				paymentRedirectUrl: window.location.origin + '/settings/profile/elite_pro_success/',
				paymentCancelUrl: window.location.origin + '/settings/profile/elite_pro_cancel/',
				onPaymentSuccess: showSuccessPaymentModal
			}
		);
	}

	function initEliteProDashboard(useLongPolling) {
		$(document.body).addClass('bg-grey-50');

		window.EliteProDashboard.launchModule(
			DASHBOARD,
			'__rctEliteProBenefitsDashboard',
			{
				useLongPolling: useLongPolling
			}
		);
	}

	function showSuccessPaymentModal(paymentData) {
		const modalElementId = '__rctEliteProSuccessModal';
		const avatarData = document.getElementById(modalElementId).dataset;

		window.EliteProDashboard.launchModule(
			'subscribe-success-modal',
			modalElementId,
			{
				renewDate: paymentData.renewDate,
				monthlyPrice: paymentData.monthlyPrice,
				avatarLetter: avatarData.avatarLetter,
				avatarColor: avatarData.avatarColor,
				avatarUrl: avatarData.avatarUrl,
				onClose: () => {
					$('#__rctEliteProLandingPage').remove();

					initEliteProDashboard(true);
				}
			}
		);
	}

	/**
	 * Fill the placeholders on the page
	 */
	function fillPlaceholders() {
		var i;
		var pn;

		$('#elite_pro.settings-page .js-currency-symbol').text(elite.seller.currency_symbol);
		$('#elite_pro.settings-page .js-seller-list-example-name')
			.eq(0)
			.text(elite.seller.company);
		$('#elite_pro.settings-page .js-seller-list-example-name')
			.eq(3)
			.text(elite.seller.company);

		if (elite.primaryCategory.id) {
			pn =
				elite.primaryCategory.provider_noun_plural ||
				_t('seller_settings_elite-pro-not-subscribed:default-provider-noun');
			$('#elite_pro.settings-page .js-seller-category-name').text(pn);
		} else {
			pn = _t('seller_settings_elite-pro-not-subscribed:default-provider-noun');
			$('#elite_pro.settings-page .js-seller-category-name').addClass('d-none');
		}
		$('#elite_pro.settings-page .js-seller-list-example-name')
			.eq(1)
			.html(
				_t('seller_settings_elite-pro-not-subscribed:company-name-examples.first', {
					category_provider_noun_plural: pn,
				}),
			);
		$('#elite_pro.settings-page .js-seller-list-example-name')
			.eq(4)
			.html(
				_t('seller_settings_elite-pro-not-subscribed:company-name-examples.first', {
					category_provider_noun_plural: pn,
				}),
			);
		$('#elite_pro.settings-page .js-seller-list-example-name')
			.eq(2)
			.html(
				_t('seller_settings_elite-pro-not-subscribed:company-name-examples.second', {
					category_provider_noun_plural: pn,
				}),
			);
		$('#elite_pro.settings-page .js-seller-list-example-name')
			.eq(5)
			.html(
				_t('seller_settings_elite-pro-not-subscribed:company-name-examples.second', {
					category_provider_noun_plural: pn,
				}),
			);

		$('#elite_pro.settings-page .js-elite-pro-subscription-free-trial')[
			freeTrialCoupon ? 'removeClass' : 'addClass'
		]('d-none');
		$('#elite_pro.settings-page .js-elite-pro-subscription-no-trial')[
			freeTrialCoupon ? 'addClass' : 'removeClass'
		]('d-none');

		standardCardModalFooterHtml = '';

		if (freeTrialCoupon) {
			standardCardModalFooterHtml += _t(
				'seller_settings_elite-pro:subscribe-plan-free-month',
			);
			$('#elite_pro.settings-page .js-requires-no-trial').remove();
			$('#elite_pro.settings-page .js-requires-trial').removeClass('d-none');
		} else {
			standardCardModalFooterHtml += _t('seller_settings_elite-pro:subscribe-plan');
			$('#elite_pro.settings-page .js-requires-trial').remove();
			$('#elite_pro.settings-page .js-requires-no-trial').removeClass('d-none');
		}

		let availableSubscription;
		for (i = 0; i < elite.availableSubscriptions.length; i++) {
			availableSubscription = elite.availableSubscriptions[i];

			if (!availableSubscription.annual) {
				$('#elite_pro.settings-page .js-elite-pro-month-price').text(
					currency(availableSubscription.price),
				);
				$('#elite_pro.settings-page .js-elite-pro-has-vat')[
					availableSubscription.has_vat || $('#js-show-tax-disclaimers-us').length
						? 'removeClass'
						: 'addClass'
				]('d-none');
				$('.js-upgrade-to-elite').data({ planId: availableSubscription.id });
				break;
			}
		}

		if (availableSubscription) {
			standardCardModalFooterHtml += ` <b>${_t(
				'seller_settings_elite-pro:monthly-price',
				{ price: currency(availableSubscription.price) },
			)}</b>`;
			if (availableSubscription.has_vat || $('#js-show-tax-disclaimers-us').length) {
				standardCardModalFooterHtml += ` ${_t('common:excluding-vat')}`;
			}
		}
	}

	function showEliteProModal(data) {
		var modal = $('#subscription-coupon-container-modal');
		var scope = $('.js-coupon-pack-container', modal);
		var i;
		var subscription;

		scope.empty();

		if (!couponSubscriptionRow) {
			couponSubscriptionRow = window.Handlebars.compile(
				document.getElementById('handlebars-subscription-coupon-row').innerHTML,
			);
		}

		$('.js-coupon-subscriptions-title', modal).text(
			data.title || _t('seller_settings_elite-pro:payment-modal-title'),
		);
		$('.js-coupon-subscription-container', modal).empty();

		for (i = 0; i < data.subscriptions.length; i++) {
			subscription = data.subscriptions[i];

			$('.js-coupon-subscription-container', modal).append(
				couponSubscriptionRow({
					id: subscription.id,
					plan_label: subscription.plan_label,
					frequency: subscription.is_annual
						? _t('seller_settings_elite-pro:coupon-subscription-year')
						: _t('seller_settings_elite-pro:coupon-subscription-month'),
					currency: '',
					price: currency(subscription.price),
					price_frequency: subscription.is_annual
						? _t("seller_settings_elite-pro:price-frequency.year", {price: currency(subscription.price)})
						: _t("seller_settings_elite-pro:price-frequency.month", {price: currency(subscription.price)}),
					bubble: subscription.bubble,
					callout: subscription.callout,
					primary_info: subscription.primary_info,
					secondary_info: subscription.secondary_info,
					selected: !subscription.is_annual || data.subscriptions.length === 1,
					payment_preamble: subscription.payment_preamble,
					has_vat: +(subscription.vat > 1) || $('#js-show-tax-disclaimers-us').length,
				}),
			);
		}

		$('.js-plan-choice-coupon')
			.off('click.select')
			.on('click.select', function () {
				var t = $(this);

				$('input.js-input-coupon-choice', t)[0].checked = true;
				$('input.js-input-coupon-choice', t).change();

				$('.plan-choice-coupon-selected').removeClass('plan-choice-coupon-selected');
				t.addClass('plan-choice-coupon-selected');
			});

		$('input.js-input-coupon-choice')
			.off('change.preamble')
			.on('change.preamble', function () {
				var data = $(this).closest('.js-plan-choice-coupon').data();
				var preamble = data.paymentPreamble;

				preamble = preamble.replace(/\[\[b\]\]/g, '<strong>');
				preamble = preamble.replace(/\[\[\/b\]\]/g, '</strong>');

				$('.js-coupon-preamble').removeClass('d-none');
				$('.js-coupon-preamble p').html(preamble);

				$('.js-coupon-subscription-full-card-container').removeClass('d-none');
				$('.js-coupon-upgrade-elite-pro-container').removeClass('d-none');
			});

		modal.modal('show');

		$('input.js-input-coupon-choice:checked').change();
	}

	/**
	 * Do purchase Elite Pro
	 * @param {Number} planId The ID of the ElitePro plan to purchase
	 * @param {String} couponCode [optional]
	 */
	async function purchaseElitePro(planId, couponCode = null) {
		var endpoint = 'seller/subscriptions';
		var params = {
			admh: $('#__admh').length ? $('#__admh').val() : null,
			admsh: $('#__admsh').length ? $('#__admsh').val() : null,
			plan_id: planId,
		};

		if (freeTrialCoupon) {
			endpoint = 'seller/subscriptions-with-coupon/';
			params['code'] = freeTrialCoupon;
		}

		if (couponCode) {
			endpoint = '/seller/subscriptions-with-coupon/';
			params['code'] = couponCode;
		}

		const paymentMethodId = paymentMethod?.id;

		if (paymentMethodId) {
			params.paymentMethodId = paymentMethodId;
		}

        params['tracking'] = getLinkAttribution() ?? {};

		barkApi(
			endpoint,
			params,
			function (e) {
				trackPurchase(e.data);

				Bark.json('/json/set-seller-elite-status/').done(function () {
					// Just wait 200ms to ensure that our GA tracking is completed.
					window.setTimeout(function () {
						document.location.reload();
					}, 200);
				});
			},
			function (error) {
				var errMsg = handleErrors(error).message;
				Bark.hideLoading();
				showPurchaseError(errMsg);
			},
			'POST',
		);
	}

	/**
	 * Show the ElitePro specific loading page
	 */
	elite.showLoading = function () {
		modalManager.set(
			'<div class="elite-pro-icon-header"><img src="https://d18jakcjgoan9.cloudfront.net/img/barkv2/material-icons/elite-pro-modal-header.svg" alt="" width="104" height="96"></div>',
			'',
			eliteWaitingModal({}),
			[],
			['elite-pro-waiting', 'waiting', 'modal-xs'],
		);
	};

	/**
	 * Show purchase errors
	 * @param {String} errorMessage The message to display to the customer
	 */
	function showPurchaseError(errorMessage) {
		clearModal($creditModal);

		errorMessage +=
			(errorMessage.substr(-1, 1) === '.' ? '' : '.') +
			' ' +
			_t('seller_settings_elite-pro:payment-modal-validation-card-details') +
			'.';
		showCardError(errorMessage);
	}

	function showCardError(errorMessage) {
		modalManager.destroy();

		showModalErrorText($creditModal, errorMessage);
		showCardModal();
	}

	/**
	 * Track the purchase of ElitePro
	 * @param subscription
	 */
	function trackPurchase(subscription) {
		window.ga?.(
			'send',
			'event',
			'backend',
			'seller_subscribed_elite',
			subscription['label'].toLowerCase(),
		);

		window.ga?.('ecommerce:addTransaction', {
			id: 'elite_' + subscription['id'],
			affiliation: subscription['seller_profile_id'],
			revenue: subscription['price'],
			shipping: '0',
			tax: '0',
		});

		window.ga?.('ecommerce:addItem', {
			id: 'elite_' + subscription['id'],
			name: subscription['name'],
			sku: 'sep_' + subscription['label'],
			category: subscription['label'],
			price: subscription['price'],
			quantity: '1',
		});

		window.ga?.('ecommerce:send');
	}

	/**
	 *
	 * @param errorResponse
	 * @param defaultMessage
	 * @returns {{message: string, validation}|{message: string}}
	 */
	function handleErrors(errorResponse, defaultMessage) {
		var message = _t('seller_settings_elite-pro:handle-errors-was-error') + '.';
		if (typeof defaultMessage !== 'undefined') {
			message = defaultMessage;
		}
		var fallbackError = true;
		var validationObj = {};
		if (typeof errorResponse.status !== 'undefined') {
			if (
				typeof errorResponse.responseJSON !== 'undefined' &&
				typeof errorResponse.responseJSON.error !== 'undefined'
			) {
				var errorObj = errorResponse.responseJSON.error || {};
				if (errorObj.status_code < 500 && typeof errorObj.message !== 'undefined') {
					message = errorObj.message;
				}
				if (errorObj.status_code === 422 && typeof errorObj.errors !== 'undefined') {
					validationObj = errorObj.errors;
					fallbackError = false;
				}
			}
		}
		if (fallbackError) {
			// for now just through alert
			return {
				message: message,
			};
		} else {
			return {
				message: message,
				validation: validationObj,
			};
		}
	}

	const showCardModal = () => {
		const preamble = overridePaymentLabelling
			? overridePaymentLabelling
				.replace(/\[\[b\]\]/g, '<strong>')
				.replace(/\[\[\/b\]\]/g, '</strong>')
			: null;

		ccShowCardModal($creditModal, {
			headerText: _t('seller_settings_elite-pro:payment-modal-title'),
			subheaderHtml: _t('seller_settings_elite-pro:payment-modal-subheader'),
			formFooterHtml: preamble ? preamble : standardCardModalFooterHtml,
		});
	};

	function couponUpgradeElitePro() {
        var couponCode = ($('#coupon-code').val() || '').trim() || null;
        var packId = $(
            '#subscription-coupon-container-modal .js-input-coupon-choice:checked',
        ).val();
        const { paymentPreamble } = $(`.js-plan-choice-coupon-${packId}`).data();

        marketingCoupon = couponCode;
        overridePaymentLabelling = paymentPreamble;

        planIdToPurchase = packId;

        $('#subscription-coupon-container-modal').modal('hide');

        if (!packId) {
            return;
        }

        if (paymentMethod?.id) {
            Bark.showLoading();
            purchaseElitePro(planIdToPurchase, marketingCoupon);
            return;
        }
        showCardModal();
    }

    function openUSTaxCompliantModal(data, context = "elite pro new") {
        $('#addressCompliance')
            .data(data)
            .modal('show');
        $('#next-button-business-address').html(_t('seller_settings_credits:us-tax-compliance.buy-credits-confirm-button'));
        $('.js-close-business-address-modal').removeClass('d-none');
        tracking('Wayfair', `US Tax Compliance - ` + context + ` begin`, {
                context: context
            },
        );
        continueToBusinessAddress(context);
    }

    function bindUSTaxComplianceNextAction($callback) {
        $('#next-button-business-address')
            .off('click')
            .on('click', async function () {
                Bark.logEvent('click', 'next button business address');
                if (isUSTaxComplianceActive()) {
                    Bark.showLoading();
                    saveBusinessAddress("Elite pro sign up", function () {
                        USTaxCompliantStatus = true;
                        let $container = $('#addressCompliance');
                        $container.modal('hide');
                        Bark.hideLoading();
                        $callback();
                    });
                }
            });
    }

    function upgradeToElitePro(planIdToPurchase) {
        if (paymentMethod?.id) {
            elite.showLoading();
            purchaseElitePro(planIdToPurchase);
        } else {
            showCardModal();
        }
    }

	$(function () {
		initPage();

		$('.js-upgrade-to-elite')
			.off('click.purchaseElite')
			.on('click.purchaseElite', function () {
				planIdToPurchase = $(this).data('plan-id');

                if (isUSTaxComplianceActive() && !USTaxCompliantStatus) {
                    let $callback = function () {
                        upgradeToElitePro(planIdToPurchase);
                    }
                    openUSTaxCompliantModal({});
                    bindUSTaxComplianceNextAction($callback);
                } else{
                    upgradeToElitePro(planIdToPurchase);
                }
			});

		$('.js-submit-elite-coupon')
			.off('click.submit-coupon')
			.on('click.submit-coupon', function () {
				var couponCode = ($('#coupon-code').val() || '').trim();

				$('.js-coupon-code-error').removeClass('d-block');
				$('#coupon-code').removeClass('border-red');

				if (!couponCode) {
					$('.js-coupon-code-error')
						.addClass('d-block')
						.text(_t('seller_settings_elite-pro:coupon-validation-code'));
					$('#coupon-code').addClass('border-red').focus();
					return;
				}

				Bark.showLoading();

				$('body').focus(); // Remove focus from the input field to prevent a double enter

				var params = {
					code: couponCode,
					admh: $('#__admh').length ? $('#__admh').val() : null,
					admsh: $('#__admsh').length ? $('#__admsh').val() : null,
					limit_to_action: [
						'purchase-subscription-coupon',
						'purchase-subscription-freebie',
					],
				};

				barkApi(
					'seller/apply-coupon',
					params,
					function (e) {
						var i;
						var pack;
						var subscription;

						if (e.data) {
							if (
								Bark.in_array(e.data.action, [
									'purchase-subscription-coupon',
									'purchase-subscription-freebie',
								])
							) {
								showEliteProModal(e.data);
							}
						} else {
							$('.js-coupon-code-error')
								.addClass('d-block')
								.text(
									(e.errors || []).length
										? e.errors.join('. ')
										: _t('seller_settings_elite-pro:coupon-validation-code'),
								);
							$('#coupon-code').addClass('border-red').focus();
						}
						Bark.hideLoading();
					},
					function (err) {
						Bark.hideLoading();
						var errorObj = handleErrors(
							err,
							_t('seller_settings_elite-pro:coupon-validation-code'),
						);
						$('.js-coupon-code-error').addClass('d-block').text(errorObj.message);
						$('#coupon-code').addClass('border-red').focus();
					},
					'POST',
				);
			});

		$('.js-coupon-upgrade-elite-pro')
			.off('click.submit')
			.on('click.submit', function () {

                if ($(this).attr('disabled')) {
                    return;
                }

                if (isUSTaxComplianceActive() && !USTaxCompliantStatus) {
                    let $callback = function () {
                        couponUpgradeElitePro();
                    }
                    openUSTaxCompliantModal({}, "elite pro free");
                    bindUSTaxComplianceNextAction($callback);
                } else{
                    couponUpgradeElitePro();
                }
			});

		$('#subscription-coupon-container-modal')
			.off('hidden.bs.modal')
			.on('hidden.bs.modal', function () {
				clearModal($creditModal);
				$('.js-coupon-subscription-full-card-container').addClass('d-none');
				$('.js-coupon-upgrade-elite-pro-container').addClass('d-none');
				$('.js-coupon-preamble').addClass('d-none');
				$('#js-elitepro-error p').addClass('d-none');
			});

		if (($('#coupon-code').val() || '').length > 0) {
			$('.js-submit-elite-coupon').trigger('click.submit-coupon');
		}
	});
}
